var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.warningVisible)?_c('v-alert',{staticClass:"caption",attrs:{"type":"warning","dense":"","outlined":""}},[_vm._v(" "+_vm._s(_vm.__('warnings.task-creation-planned-hours'))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }